export enum BriefingOrganizeByApiEnum {
    MANUAL = 'MANUAL',
    SENTIMENT = 'SENTIMENT',
    MEDIA_TYPE = 'MEDIA_TYPE',
    TAGS = 'TAGS',
    FOLDERS = 'FOLDERS',
    ALL = 'ALL'
}
